import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width="58.705719mm"
    height="8.1400995mm"
    viewBox="0 0 58.705719 8.1400995"
    id="svg19170"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs19167" />
    <g id="layer1" transform="translate(361.59019,322.46415)">
      <path
        fillRule="nonzero"
        fill="#ed192d"
        fillOpacity={1}
        d="m -358.06793,-322.42276 c -1.90582,0 -3.45198,1.80248 -3.45198,4.02525 0,2.2214 1.54616,4.0225 3.45198,4.0225 1.90583,0 3.45061,-1.8011 3.45061,-4.0225 0,-2.22277 -1.54478,-4.02525 -3.45061,-4.02525"
        id="path14570"
        style={{
          strokeWidth: 0.352778,
          fill: "#c31d24",
          fillOpacity: 1,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -360.47398,-316.47239 c -0.31006,-0.55121 -0.49058,-1.21267 -0.49058,-1.92512 0,-0.71382 0.18052,-1.37528 0.49058,-1.92649 v 3.85161"
        id="path14572"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -359.74087,-321.22248 c 0.19293,-0.16399 0.40239,-0.29904 0.62701,-0.40239 v 6.45335 c -0.22462,-0.10335 -0.43408,-0.2384 -0.62701,-0.40239 v -5.64857"
        id="path14574"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -358.38074,-321.83847 c 0.10335,-0.0124 0.2067,-0.0193 0.31281,-0.0193 0.10473,0 0.21084,0.007 0.31419,0.0193 v 6.87917 c -0.10335,0.0138 -0.20946,0.0207 -0.31419,0.0207 -0.10611,0 -0.20946,-0.007 -0.31281,-0.0193 v -6.88054"
        id="path14576"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -357.02062,-321.62487 c 0.22324,0.10473 0.43408,0.23978 0.62701,0.40376 v 5.64583 c -0.19293,0.1626 -0.40377,0.29903 -0.62701,0.40238 v -6.45197"
        id="path14578"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -355.66049,-320.31987 c 0.30868,0.54984 0.48782,1.20992 0.48782,1.92236 0,0.70969 -0.17914,1.37115 -0.48782,1.92099 v -3.84335"
        id="path14580"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -356.39361,-321.56837 v 0.19292 c -0.19431,-0.15434 -0.40377,-0.2825 -0.62701,-0.38034 v -0.16812 c 0.22187,0.0923 0.43133,0.21222 0.62701,0.35554"
        id="path14582"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -358.06793,-322.13337 c 0.10473,0 0.21084,0.007 0.31419,0.0179 v 0.15572 c -0.10335,-0.0124 -0.20946,-0.0193 -0.31419,-0.0193 -0.10611,0 -0.20946,0.007 -0.31281,0.0193 v -0.15572 c 0.10335,-0.011 0.2067,-0.0179 0.31281,-0.0179"
        id="path14584"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -359.11386,-321.92391 v 0.16675 c -0.22186,0.0978 -0.4327,0.226 -0.62701,0.38034 v -0.19293 c 0.19569,-0.14332 0.40515,-0.26321 0.62701,-0.35416"
        id="path14586"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -361.23328,-318.39751 c 0,-0.92742 0.28525,-1.77491 0.7593,-2.4281 v 0.27147 c -0.38172,0.60083 -0.60772,1.34635 -0.60772,2.15663 0,0.80891 0.226,1.55581 0.60772,2.15525 v 0.27148 c -0.47405,-0.65319 -0.7593,-1.50068 -0.7593,-2.42673"
        id="path14588"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -359.74087,-315.22664 v -0.19293 c 0.19431,0.15434 0.40515,0.2825 0.62701,0.38034 v 0.16812 c -0.22186,-0.0923 -0.43132,-0.21222 -0.62701,-0.35553"
        id="path14590"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -358.06793,-314.66302 c -0.10611,0 -0.20946,-0.006 -0.31281,-0.0179 v -0.15572 c 0.10335,0.0124 0.2067,0.0193 0.31281,0.0193 0.10473,0 0.21084,-0.007 0.31419,-0.0193 v 0.15572 c -0.10335,0.0124 -0.20946,0.0179 -0.31419,0.0179"
        id="path14592"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -357.02062,-314.87248 v -0.16813 c 0.22324,-0.0978 0.4327,-0.22599 0.62701,-0.38033 v 0.19292 c -0.19568,0.14469 -0.40514,0.26321 -0.62701,0.35554"
        id="path14594"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -355.66049,-316.24639 c 0.38033,-0.59944 0.60495,-1.34359 0.60495,-2.15112 0,-0.80891 -0.22462,-1.55305 -0.60495,-2.15249 v -0.27148 c 0.47266,0.65182 0.75792,1.49793 0.75792,2.42397 0,0.92467 -0.28526,1.77078 -0.75792,2.4226 v -0.27148"
        id="path14596"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ed192d"
        fillOpacity={1}
        d="m -354.70689,-314.78567 c 0.022,-0.1006 0.1061,-0.19706 0.16123,-0.27836 -0.0717,-0.0345 -0.16123,-0.0827 -0.22324,-0.13643 0.13642,-0.20395 0.18465,-0.3073 0.2067,-0.55259 l -0.0179,-1.27607 h -0.0179 c -0.11162,0.3831 -0.26045,0.80616 -0.47405,1.11897 -0.0606,0.0896 -0.0717,0.113 -0.1061,0.16537 -0.0414,0.0648 -0.1323,0.19705 -0.12954,0.42168 -0.0758,0.0165 -0.16812,-0.004 -0.25769,-0.011 0.011,0.0965 0.0234,0.11576 -10e-4,0.27423 -0.36931,0.0138 -0.43959,0.2384 -0.83784,0.4451 -0.1819,0.0951 -0.25907,0.1323 -0.49885,0.22187 v 0.022 c 0.7469,-0.0248 1.07625,0.0978 1.49241,-0.1819 0.0482,0.0648 0.073,0.15296 0.10611,0.22875 0.0579,-0.0469 0.18604,-0.12953 0.28112,-0.15434 0.11025,0.10887 0.27285,0.16812 0.46165,0.15158 0.0275,-0.15158 -0.0262,-0.35691 -0.1447,-0.45888"
        id="path14598"
        style={{
          strokeWidth: 0.352778,
          fill: "#c31d24",
          fillOpacity: 1,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -354.6435,-315.03923 c -0.0482,0.0207 -0.30317,0.10611 -0.30317,0.10611 l -0.003,0.003 c -10e-4,-0.0207 -0.006,-0.04 -0.0152,-0.0593 l -10e-4,-0.004 c 0.0896,-0.0538 0.13504,-0.12403 0.13642,-0.13505 -10e-4,-0.001 0.008,-0.011 0.01,-0.011 0,0 0,0.001 0,0.003 0.008,0.01 0.10749,0.0841 0.17639,0.0978"
        id="path14600"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -354.81989,-316.19678 c 0.19706,-0.5085 0.16123,-0.52503 0.21773,-0.73725 -0.0565,0.71107 -0.2701,1.29811 -0.47543,1.83555 0,0 -0.0469,-0.0138 -0.0717,-0.008 -0.0427,-0.0496 -0.0524,-0.1199 -0.0524,-0.1199 -0.10611,-0.34727 0.226,-0.57051 0.38172,-0.97014"
        id="path14602"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -355.48962,-315.25696 0.22738,0.18879 v 0.003 c -0.007,0.004 -0.0124,0.01 -0.0193,0.0152 -0.011,0.011 -0.0193,0.0234 -0.0262,0.0358 l -10e-4,0.003 c -0.11024,-0.0524 -0.1819,-0.0524 -0.1819,-0.0524 0.0276,-0.11851 10e-4,-0.19292 10e-4,-0.19292"
        id="path14604"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -356.79324,-314.40257 0.28938,-0.091 c 0.45889,-0.16536 0.62288,-0.50711 0.96739,-0.48782 0.073,0.008 0.13505,0.0234 0.19568,0.0579 -10e-4,0.022 0.006,0.0482 0.0124,0.0703 h -0.005 c -0.28802,0.17363 -0.91778,0.37207 -1.45935,0.45062"
        id="path14606"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -355.27602,-314.41911 c -0.0138,-0.0358 -0.0207,-0.11989 -0.0717,-0.17639 0.0689,-0.0593 0.0841,-0.0909 0.10611,-0.14883 l 0.003,10e-4 c 0.0207,0.0124 0.0455,0.0193 0.0703,0.0221 h 0.003 l -0.11024,0.30179"
        id="path14608"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -355.22228,-314.83252 c -0.0441,-0.0441 -0.0441,-0.11576 0,-0.15986 0.0441,-0.0441 0.11576,-0.0441 0.15985,0 0.0441,0.0441 0.0441,0.11576 0,0.15986 -0.0455,0.0441 -0.11575,0.0441 -0.15985,0"
        id="path14610"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -355.00455,-314.57621 c -0.051,-0.0593 -0.0469,-0.0786 -0.0661,-0.15847 0.0248,-0.008 0.0634,-0.0345 0.0813,-0.0593 l 0.35278,0.38034 c -0.13092,0.0124 -0.28664,-0.0634 -0.36794,-0.16261"
        id="path14612"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ed192d"
        fillOpacity={1}
        d="m -354.70689,-321.99419 c 0.022,0.0992 0.1061,0.19706 0.16123,0.27837 -0.0717,0.0344 -0.16123,0.0827 -0.22324,0.13504 0.13642,0.20533 0.18465,0.30731 0.2067,0.55397 l -0.0179,1.27607 h -0.0179 c -0.11162,-0.3831 -0.26045,-0.80753 -0.47405,-1.11897 -0.0606,-0.0896 -0.0717,-0.113 -0.1061,-0.16536 -0.0414,-0.0648 -0.1323,-0.19706 -0.12954,-0.42306 -0.0758,-0.0152 -0.16812,0.004 -0.25769,0.011 0.011,-0.0965 0.0234,-0.11438 -10e-4,-0.27285 -0.36931,-0.0138 -0.43959,-0.23978 -0.83784,-0.44649 -0.1819,-0.0937 -0.25907,-0.13229 -0.49885,-0.22186 v -0.0207 c 0.7469,0.0248 1.07625,-0.0978 1.49241,0.18191 0.0482,-0.0648 0.073,-0.15434 0.10611,-0.22876 0.0579,0.0455 0.18604,0.12954 0.28112,0.15434 0.11025,-0.10886 0.27285,-0.1695 0.46165,-0.15158 0.0275,0.15158 -0.0262,0.35553 -0.1447,0.45889"
        id="path14614"
        style={{
          strokeWidth: 0.352778,
          fill: "#c31d24",
          fillOpacity: 1,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -354.6435,-321.74201 c -0.0482,-0.0193 -0.30317,-0.10473 -0.30317,-0.10473 l -0.003,-0.003 c -10e-4,0.0193 -0.006,0.04 -0.0152,0.0593 l -10e-4,0.004 c 0.0896,0.0524 0.13504,0.12403 0.13642,0.13505 -10e-4,0 0.008,0.01 0.01,0.01 0,0 0,0 0,-10e-4 0.008,-0.01 0.10749,-0.0854 0.17639,-0.0992"
        id="path14616"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -354.81989,-320.58307 c 0.19706,0.50849 0.16123,0.52503 0.21773,0.73587 -0.0565,-0.71107 -0.2701,-1.29811 -0.47543,-1.83555 0,0 -0.0469,0.0138 -0.0717,0.01 -0.0427,0.0496 -0.0524,0.11989 -0.0524,0.11989 -0.10611,0.34727 0.226,0.56913 0.38172,0.97014"
        id="path14618"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -355.48962,-321.52427 0.22738,-0.1888 v -10e-4 c -0.007,-0.004 -0.0124,-0.011 -0.0193,-0.0152 -0.011,-0.0124 -0.0193,-0.0234 -0.0262,-0.0358 l -10e-4,-0.004 c -0.11024,0.0537 -0.1819,0.0537 -0.1819,0.0537 0.0276,0.11851 10e-4,0.19155 10e-4,0.19155"
        id="path14620"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -356.79324,-322.37728 0.28938,0.0909 c 0.45889,0.16398 0.62288,0.50574 0.96739,0.48645 0.073,-0.008 0.13505,-0.0221 0.19568,-0.0565 -10e-4,-0.022 0.006,-0.0482 0.0124,-0.0703 h -0.005 c -0.28802,-0.17501 -0.91778,-0.37345 -1.45935,-0.45062"
        id="path14622"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -355.27602,-322.36075 c -0.0138,0.0345 -0.0207,0.11852 -0.0717,0.17639 0.0689,0.0579 0.0841,0.091 0.10611,0.14883 l 0.003,-0.001 c 0.0207,-0.0138 0.0455,-0.0207 0.0703,-0.022 h 0.003 l -0.11024,-0.30179"
        id="path14624"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -355.22228,-321.94733 c -0.0441,0.0441 -0.0441,0.11575 0,0.15985 0.0441,0.0427 0.11576,0.0427 0.15985,-10e-4 0.0441,-0.0441 0.0441,-0.11576 0,-0.15986 -0.0455,-0.0441 -0.11575,-0.0441 -0.15985,10e-4"
        id="path14626"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -355.00455,-322.20503 c -0.051,0.0606 -0.0469,0.0786 -0.0661,0.15985 0.0248,0.007 0.0634,0.0345 0.0813,0.0593 l 0.35278,-0.38172 c -0.13092,-0.011 -0.28664,0.0648 -0.36794,0.16261"
        id="path14628"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ed192d"
        fillOpacity={1}
        d="m -361.42896,-314.79256 c -0.0234,-0.1006 -0.10611,-0.19706 -0.16123,-0.27836 0.0703,-0.0345 0.16123,-0.0827 0.22186,-0.13643 -0.13505,-0.20533 -0.18328,-0.3073 -0.20533,-0.55259 l 0.0179,-1.27744 h 0.0179 c 0.11162,0.38447 0.26044,0.80753 0.47267,1.12172 0.0606,0.0882 0.073,0.11162 0.10748,0.16399 0.0413,0.0634 0.13229,0.19705 0.12816,0.42168 0.0772,0.0165 0.1695,-0.004 0.25907,-0.011 -0.0124,0.0978 -0.0248,0.11576 10e-4,0.27423 0.36794,0.0138 0.43959,0.23978 0.83647,0.4451 0.18328,0.0951 0.25907,0.1323 0.50023,0.22187 v 0.0207 c -0.7469,-0.0221 -1.07625,0.0992 -1.4938,-0.18052 -0.0482,0.0648 -0.073,0.15296 -0.10473,0.22875 -0.0593,-0.0469 -0.18603,-0.12953 -0.28112,-0.15434 -0.11024,0.10887 -0.27423,0.1695 -0.46302,0.15159 -0.0262,-0.15159 0.0262,-0.35691 0.14607,-0.45889"
        id="path14630"
        style={{
          strokeWidth: 0.352778,
          fill: "#c31d24",
          fillOpacity: 1,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -361.49373,-315.04612 c 0.0496,0.0207 0.30317,0.10611 0.30317,0.10611 l 0.004,0.003 c 0,-0.0207 0.005,-0.04 0.0138,-0.0593 l 10e-4,-0.004 c -0.0896,-0.0537 -0.13367,-0.12402 -0.13505,-0.13505 0,-0.001 -0.01,-0.011 -0.01,-0.011 -0.001,0 -0.001,0.001 -0.001,0.001 -0.007,0.011 -0.10749,0.0854 -0.17639,0.0992"
        id="path14632"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -361.31596,-316.20367 c -0.19706,-0.5085 -0.16261,-0.52503 -0.21773,-0.73725 0.0565,0.71107 0.26871,1.29811 0.47404,1.83555 0,0 0.0482,-0.0138 0.0717,-0.01 0.0427,-0.0482 0.0524,-0.11852 0.0524,-0.11852 0.10612,-0.34726 -0.22599,-0.57051 -0.38033,-0.97014"
        id="path14634"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -360.64624,-315.26385 -0.22737,0.18879 -0.001,0.001 c 0.007,0.006 0.0138,0.011 0.0193,0.0165 0.011,0.011 0.0207,0.0234 0.0276,0.0358 l 0.001,0.004 c 0.11024,-0.0538 0.1819,-0.0538 0.1819,-0.0538 -0.0289,-0.11851 -10e-4,-0.19292 -10e-4,-0.19292"
        id="path14636"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -359.34261,-314.41084 -0.28939,-0.0896 c -0.45889,-0.16398 -0.62287,-0.50574 -0.96738,-0.48644 -0.0744,0.007 -0.13643,0.022 -0.19706,0.0565 0.003,0.022 -0.004,0.0482 -0.011,0.0703 h 0.004 c 0.28939,0.17363 0.91915,0.37207 1.46072,0.44924"
        id="path14638"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -360.86121,-314.426 c 0.0138,-0.0358 0.0221,-0.11989 0.073,-0.17639 -0.0689,-0.0593 -0.0841,-0.0909 -0.10748,-0.14883 l -10e-4,10e-4 c -0.0221,0.0124 -0.0469,0.0193 -0.0703,0.0221 h -0.003 l 0.10886,0.30179"
        id="path14640"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -360.91358,-314.83941 c 0.0441,-0.0441 0.0441,-0.11576 0,-0.15986 -0.0441,-0.0441 -0.11575,-0.0441 -0.15985,0 -0.0441,0.0441 -0.0441,0.11576 0,0.15986 0.0441,0.0441 0.11576,0.0441 0.15985,0"
        id="path14642"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -361.13268,-314.5831 c 0.051,-0.0593 0.0482,-0.0786 0.0675,-0.15847 -0.0262,-0.008 -0.0634,-0.0345 -0.0813,-0.0579 l -0.35416,0.37896 c 0.13229,0.0124 0.28663,-0.0634 0.36794,-0.16261"
        id="path14644"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ed192d"
        fillOpacity={1}
        d="m -361.42896,-322.00108 c -0.0234,0.0992 -0.10611,0.19706 -0.16123,0.27837 0.0703,0.0344 0.16123,0.0827 0.22186,0.13504 -0.13505,0.20533 -0.18328,0.30869 -0.20533,0.55398 l 0.0179,1.27606 h 0.0179 c 0.11162,-0.38447 0.26044,-0.80753 0.47267,-1.12035 0.0606,-0.0882 0.073,-0.11162 0.10748,-0.16398 0.0413,-0.0648 0.13229,-0.19706 0.12816,-0.42306 0.0772,-0.0152 0.1695,0.004 0.25907,0.011 -0.0124,-0.0965 -0.0248,-0.11438 10e-4,-0.27285 0.36794,-0.0138 0.43959,-0.23978 0.83647,-0.44511 0.18328,-0.0951 0.25907,-0.13367 0.50023,-0.22324 v -0.0207 c -0.7469,0.0234 -1.07625,-0.0978 -1.4938,0.18191 -0.0482,-0.0648 -0.073,-0.15434 -0.10473,-0.23014 -0.0593,0.0469 -0.18603,0.13092 -0.28112,0.15572 -0.11024,-0.10886 -0.27423,-0.1695 -0.46302,-0.15296 -0.0262,0.15296 0.0262,0.35691 0.14607,0.46026"
        id="path14646"
        style={{
          strokeWidth: 0.352778,
          fill: "#c31d24",
          fillOpacity: 1,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -361.49373,-321.7489 c 0.0496,-0.0193 0.30317,-0.10473 0.30317,-0.10473 l 0.004,-0.003 c 0,0.0193 0.005,0.04 0.0138,0.0579 l 10e-4,0.005 c -0.0896,0.0524 -0.13367,0.12264 -0.13505,0.13505 0,10e-4 -0.01,0.011 -0.01,0.01 -0.001,0 -0.001,0 -0.001,-10e-4 -0.007,-0.01 -0.10749,-0.0841 -0.17639,-0.0992"
        id="path14648"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -361.31596,-320.58997 c -0.19706,0.5085 -0.16261,0.52504 -0.21773,0.73588 0.0565,-0.71107 0.26871,-1.29812 0.47404,-1.83555 0,0 0.0482,0.0152 0.0717,0.011 0.0427,0.0482 0.0524,0.11851 0.0524,0.11851 0.10612,0.34726 -0.22599,0.56913 -0.38033,0.97013"
        id="path14650"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -360.64624,-321.53116 -0.22737,-0.1888 h -0.001 c 0.007,-0.005 0.0138,-0.011 0.0193,-0.0165 0.011,-0.0124 0.0207,-0.0234 0.0276,-0.0358 l 0.001,-0.004 c 0.11024,0.0537 0.1819,0.0537 0.1819,0.0537 -0.0289,0.11851 -10e-4,0.19155 -10e-4,0.19155"
        id="path14652"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -359.34261,-322.38279 -0.28939,0.0896 c -0.45889,0.16398 -0.62287,0.50574 -0.96738,0.48645 -0.0744,-0.008 -0.13643,-0.0221 -0.19706,-0.0565 0.003,-0.0234 -0.004,-0.0482 -0.011,-0.0703 h 0.004 c 0.28939,-0.17501 0.91915,-0.37345 1.46072,-0.44924"
        id="path14654"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -360.86121,-322.36764 c 0.0138,0.0345 0.0221,0.11852 0.073,0.17639 -0.0689,0.0593 -0.0841,0.091 -0.10748,0.14745 h -10e-4 c -0.0221,-0.0124 -0.0469,-0.0207 -0.0703,-0.0221 h -0.003 l 0.10886,-0.30179"
        id="path14656"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -360.91358,-321.95422 c 0.0441,0.0441 0.0441,0.11575 0,0.15985 -0.0441,0.0441 -0.11575,0.0441 -0.15985,-10e-4 -0.0441,-0.0427 -0.0441,-0.11576 0,-0.15986 0.0441,-0.0441 0.11576,-0.0427 0.15985,10e-4"
        id="path14658"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -361.13268,-322.21192 c 0.051,0.0606 0.0482,0.0799 0.0675,0.15985 -0.0262,0.007 -0.0634,0.0331 -0.0813,0.0579 l -0.35416,-0.38034 c 0.13229,-0.0124 0.28663,0.0648 0.36794,0.16261"
        id="path14660"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -349.51582,-314.42187 v -1.53651 h -1.28158 v 0.24529 h 1.02802 c 0.003,0.16123 -0.0179,0.30868 -0.0634,0.44511 -0.0455,0.13504 -0.113,0.25218 -0.20395,0.3514 -0.0896,0.0978 -0.2012,0.17639 -0.33349,0.23288 -0.13091,0.0524 -0.27836,0.0799 -0.4451,0.0799 -0.19982,0 -0.37207,-0.0386 -0.51677,-0.11437 -0.14331,-0.0758 -0.26182,-0.17639 -0.35553,-0.30042 -0.0896,-0.12678 -0.1571,-0.27009 -0.20257,-0.42719 -0.0427,-0.16123 -0.0634,-0.32384 -0.0634,-0.48783 0,-0.16536 0.0207,-0.32797 0.0634,-0.48644 0.0455,-0.1571 0.113,-0.29904 0.20257,-0.42306 0.0937,-0.12678 0.21222,-0.22875 0.35553,-0.30455 0.1447,-0.0758 0.31695,-0.11437 0.51677,-0.11437 0.14469,0 0.27423,0.0234 0.38998,0.0716 0.11576,0.0455 0.2136,0.10474 0.29628,0.17777 0.0841,0.073 0.15021,0.15572 0.19844,0.24529 0.051,0.0882 0.0813,0.17501 0.0896,0.26321 h 0.28801 c -0.0289,-0.16675 -0.0813,-0.31282 -0.15709,-0.43684 -0.0758,-0.12403 -0.1695,-0.22875 -0.27975,-0.31281 -0.11024,-0.0854 -0.23564,-0.14745 -0.3762,-0.19018 -0.14194,-0.0427 -0.29077,-0.0634 -0.44924,-0.0634 -0.23702,0 -0.44649,0.0427 -0.62701,0.13091 -0.17639,0.0841 -0.32522,0.19982 -0.44373,0.34726 -0.11851,0.14332 -0.20808,0.31006 -0.26734,0.49886 -0.0593,0.19016 -0.0882,0.3886 -0.0882,0.59668 0,0.20947 0.0289,0.4079 0.0882,0.5967 0.0593,0.19016 0.14883,0.35691 0.26734,0.50022 0.11851,0.14332 0.26734,0.26045 0.44373,0.34727 0.18052,0.0841 0.38999,0.12678 0.62701,0.12678 0.11024,0 0.21635,-0.011 0.31833,-0.0331 0.10335,-0.0234 0.20119,-0.0579 0.29076,-0.1061 0.0909,-0.051 0.17363,-0.11438 0.24667,-0.19155 0.0758,-0.0785 0.13918,-0.17226 0.19017,-0.27837 h 0.008 l 0.0386,0.54984 h 0.20671"
        id="path14662"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -348.08955,-316.66945 c -0.16537,0 -0.3142,0.0303 -0.44373,0.0937 -0.12678,0.0606 -0.23427,0.14469 -0.32246,0.24942 -0.0868,0.10336 -0.15296,0.22738 -0.19844,0.36794 -0.0455,0.13781 -0.0675,0.28663 -0.0675,0.44373 0,0.15847 0.0221,0.30868 0.0675,0.44924 0.0455,0.1378 0.11162,0.26045 0.19844,0.3638 0.0882,0.10473 0.19568,0.18741 0.32246,0.2508 0.12953,0.0593 0.27836,0.0882 0.44373,0.0882 0.16674,0 0.31419,-0.0289 0.44097,-0.0882 0.12953,-0.0634 0.2384,-0.14607 0.3266,-0.2508 0.0868,-0.10335 0.15296,-0.226 0.19843,-0.3638 0.0455,-0.14056 0.0675,-0.29077 0.0675,-0.44924 0,-0.1571 -0.022,-0.30592 -0.0675,-0.44373 -0.0455,-0.14056 -0.11162,-0.26458 -0.19843,-0.36794 -0.0882,-0.10473 -0.19707,-0.18879 -0.3266,-0.24942 -0.12678,-0.0634 -0.27423,-0.0937 -0.44097,-0.0937 z m 0,0.22462 c 0.12816,0 0.2384,0.0262 0.33486,0.0799 0.0965,0.0537 0.17501,0.12402 0.23702,0.21222 0.0648,0.0868 0.113,0.18741 0.1447,0.30041 0.0331,0.11024 0.051,0.22186 0.051,0.33762 0,0.11575 -0.0179,0.23151 -0.051,0.34313 -0.0317,0.11024 -0.0799,0.20946 -0.1447,0.29628 -0.062,0.0882 -0.14056,0.15847 -0.23702,0.21222 -0.0965,0.0537 -0.2067,0.0799 -0.33486,0.0799 -0.12678,0 -0.23703,-0.0262 -0.33349,-0.0799 -0.0965,-0.0537 -0.17639,-0.12403 -0.24115,-0.21222 -0.062,-0.0868 -0.11025,-0.18604 -0.1447,-0.29628 -0.0303,-0.11162 -0.0469,-0.22738 -0.0469,-0.34313 0,-0.11576 0.0165,-0.22738 0.0469,-0.33762 0.0345,-0.113 0.0827,-0.2136 0.1447,-0.30041 0.0648,-0.0882 0.14469,-0.15848 0.24115,-0.21222 0.0965,-0.0538 0.20671,-0.0799 0.33349,-0.0799"
        id="path14664"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -346.90306,-316.60606 0.84198,2.18419 h 0.28387 l 0.81718,-2.18419 h -0.27561 l -0.67799,1.91823 h -0.008 l -0.68488,-1.91823 h -0.29628"
        id="path14666"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -344.5411,-315.44162 h 1.67982 c 0.006,-0.15296 -0.008,-0.30178 -0.0413,-0.44923 -0.0345,-0.14883 -0.0909,-0.28113 -0.1695,-0.39275 -0.0772,-0.11575 -0.17639,-0.20946 -0.30041,-0.27974 -0.12402,-0.0717 -0.27423,-0.10611 -0.44924,-0.10611 -0.17225,0 -0.32108,0.0344 -0.44786,0.10198 -0.1254,0.0648 -0.226,0.15158 -0.30593,0.26183 -0.0785,0.10748 -0.1378,0.23013 -0.17776,0.36793 -0.0358,0.13918 -0.0551,0.27974 -0.0551,0.42306 0,0.15572 0.0193,0.30454 0.0551,0.4451 0.04,0.13919 0.0992,0.26045 0.17776,0.36794 0.0799,0.10473 0.18053,0.18741 0.30593,0.2508 0.12678,0.0593 0.27561,0.0882 0.44786,0.0882 0.27699,0 0.4892,-0.0675 0.63941,-0.20257 0.15159,-0.13643 0.25631,-0.32798 0.31282,-0.57602 h -0.26597 c -0.0427,0.1695 -0.11851,0.30454 -0.22875,0.40652 -0.11024,0.1006 -0.26321,0.15158 -0.45751,0.15158 -0.12678,0 -0.23564,-0.0262 -0.32659,-0.0799 -0.0896,-0.0537 -0.16399,-0.12127 -0.22325,-0.20395 -0.0593,-0.0813 -0.10335,-0.17364 -0.13229,-0.27423 -0.0248,-0.10473 -0.0372,-0.20533 -0.0372,-0.30042 z m 1.41386,-0.22461 h -1.41386 c 0.011,-0.0992 0.033,-0.19431 0.0675,-0.28802 0.0372,-0.0965 0.0854,-0.17914 0.14332,-0.24942 0.0606,-0.073 0.13229,-0.13092 0.21635,-0.17363 0.0841,-0.0455 0.1819,-0.0675 0.29214,-0.0675 0.10749,0 0.20257,0.0221 0.28801,0.0675 0.0841,0.0427 0.1571,0.10059 0.21635,0.17363 0.0593,0.0703 0.10336,0.15159 0.13505,0.24529 0.0331,0.0923 0.0524,0.19017 0.0551,0.29215"
        id="path14668"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -342.50161,-316.60606 v 2.18419 h 0.26734 v -1.16444 c 0,-0.11576 0.0193,-0.22186 0.0593,-0.31695 0.04,-0.0992 0.0951,-0.18328 0.16536,-0.25356 0.073,-0.0717 0.15986,-0.12402 0.25769,-0.16123 0.0992,-0.04 0.20947,-0.0565 0.33073,-0.051 v -0.26597 c -0.19843,-0.01 -0.36793,0.0345 -0.51263,0.13092 -0.14056,0.0951 -0.24529,0.23288 -0.31281,0.41065 h -0.008 v -0.51263 h -0.24667"
        id="path14670"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -341.1718,-316.60606 v 2.18419 h 0.26734 v -1.27331 c 0.003,-0.10748 0.0193,-0.2067 0.0496,-0.29765 0.0345,-0.0923 0.0799,-0.17088 0.13642,-0.23702 0.0593,-0.0675 0.12954,-0.11989 0.21084,-0.15572 0.0854,-0.04 0.18053,-0.0593 0.28801,-0.0593 0.10749,0 0.19706,0.0166 0.26734,0.0496 0.073,0.0345 0.13092,0.0813 0.17364,0.14056 0.0413,0.0593 0.0716,0.12954 0.0882,0.21084 0.0179,0.0799 0.0262,0.16537 0.0262,0.25907 v 1.36288 h 0.26595 v -1.4056 c 0,-0.12953 -0.0124,-0.24666 -0.0372,-0.3514 -0.0262,-0.10335 -0.0703,-0.19154 -0.13229,-0.26182 -0.062,-0.0744 -0.1447,-0.12954 -0.24943,-0.1695 -0.10197,-0.04 -0.22875,-0.0593 -0.38034,-0.0593 -0.15572,0 -0.29765,0.0413 -0.42856,0.12265 -0.12954,0.0786 -0.21911,0.18466 -0.2701,0.31695 h -0.008 v -0.37621 h -0.26733"
        id="path14672"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -338.89391,-316.60606 v 2.18419 h 0.26597 v -1.21956 c 0,-0.11576 0.0138,-0.22049 0.0386,-0.31695 0.0248,-0.0992 0.0634,-0.18328 0.11438,-0.25356 0.0537,-0.0744 0.12127,-0.12954 0.20257,-0.1695 0.0854,-0.0427 0.18328,-0.0634 0.29628,-0.0634 0.0854,0 0.1571,0.0138 0.21635,0.0413 0.0593,0.0289 0.10611,0.0689 0.13918,0.11989 0.0372,0.0469 0.0634,0.10473 0.0772,0.17226 0.0165,0.0661 0.0248,0.13505 0.0248,0.20808 v 1.48139 h 0.26734 v -1.2361 c 0,-0.10197 0.008,-0.19844 0.0248,-0.29214 0.0193,-0.0951 0.0524,-0.18052 0.0978,-0.25356 0.0455,-0.073 0.1061,-0.13092 0.1819,-0.17363 0.0758,-0.0455 0.17225,-0.0675 0.28801,-0.0675 0.19154,0 0.32521,0.0482 0.40238,0.14332 0.0758,0.0937 0.11438,0.23013 0.11438,0.41066 v 1.46898 h 0.26596 v -1.48139 c 0,-0.51125 -0.24115,-0.76619 -0.72347,-0.76619 -0.14469,0 -0.27974,0.0344 -0.40652,0.10611 -0.12678,0.0703 -0.22324,0.17777 -0.28801,0.32108 -0.04,-0.14331 -0.11851,-0.2508 -0.23702,-0.32108 -0.11576,-0.0717 -0.24529,-0.10611 -0.38999,-0.10611 -0.17776,0 -0.32383,0.0372 -0.43959,0.11438 -0.113,0.0758 -0.20533,0.1819 -0.27561,0.31695 h -0.0124 v -0.36794 h -0.24529"
        id="path14674"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -335.21179,-315.44162 h 1.68121 c 0.005,-0.15296 -0.008,-0.30178 -0.0427,-0.44923 -0.0331,-0.14883 -0.0896,-0.28113 -0.1695,-0.39275 -0.0758,-0.11575 -0.17639,-0.20946 -0.30041,-0.27974 -0.12402,-0.0717 -0.27285,-0.10611 -0.44786,-0.10611 -0.17226,0 -0.32246,0.0344 -0.44924,0.10198 -0.12403,0.0648 -0.226,0.15158 -0.30455,0.26183 -0.0786,0.10748 -0.1378,0.23013 -0.17776,0.36793 -0.0372,0.13918 -0.0551,0.27974 -0.0551,0.42306 0,0.15572 0.0179,0.30454 0.0551,0.4451 0.04,0.13919 0.0992,0.26045 0.17776,0.36794 0.0786,0.10473 0.18052,0.18741 0.30455,0.2508 0.12678,0.0593 0.27698,0.0882 0.44924,0.0882 0.2756,0 0.4892,-0.0675 0.63941,-0.20257 0.15158,-0.13643 0.25631,-0.32798 0.31281,-0.57602 h -0.26734 c -0.0413,0.1695 -0.11851,0.30454 -0.22875,0.40652 -0.10887,0.1006 -0.26183,0.15158 -0.45613,0.15158 -0.12678,0 -0.23565,-0.0262 -0.3266,-0.0799 -0.0896,-0.0537 -0.16536,-0.12127 -0.22462,-0.20395 -0.0593,-0.0813 -0.10197,-0.17364 -0.13091,-0.27423 -0.0248,-0.10473 -0.0386,-0.20533 -0.0386,-0.30042 z m 1.41387,-0.22461 h -1.41387 c 0.0124,-0.0992 0.0345,-0.19431 0.0689,-0.28802 0.0358,-0.0965 0.0841,-0.17914 0.14332,-0.24942 0.0593,-0.073 0.13092,-0.13092 0.21635,-0.17363 0.0841,-0.0455 0.1819,-0.0675 0.29215,-0.0675 0.10611,0 0.20257,0.0221 0.28801,0.0675 0.0841,0.0427 0.15571,0.10059 0.21497,0.17363 0.0593,0.0703 0.10473,0.15159 0.13643,0.24529 0.0331,0.0923 0.051,0.19017 0.0537,0.29215"
        id="path14676"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -333.17505,-316.60606 v 2.18419 h 0.26734 v -1.27331 c 0.003,-0.10748 0.0193,-0.2067 0.0496,-0.29765 0.0345,-0.0923 0.0799,-0.17088 0.13643,-0.23702 0.0593,-0.0675 0.12953,-0.11989 0.21084,-0.15572 0.0854,-0.04 0.18052,-0.0593 0.28801,-0.0593 0.10749,0 0.19706,0.0166 0.26734,0.0496 0.073,0.0345 0.13091,0.0813 0.17363,0.14056 0.0413,0.0593 0.0717,0.12954 0.0882,0.21084 0.0179,0.0799 0.0262,0.16537 0.0262,0.25907 v 1.36288 h 0.26596 v -1.4056 c 0,-0.12953 -0.0124,-0.24666 -0.0372,-0.3514 -0.0262,-0.10335 -0.0703,-0.19154 -0.13229,-0.26182 -0.062,-0.0744 -0.14469,-0.12954 -0.24942,-0.1695 -0.10198,-0.04 -0.22875,-0.0593 -0.38034,-0.0593 -0.15572,0 -0.29766,0.0413 -0.42857,0.12265 -0.12953,0.0786 -0.21911,0.18466 -0.2701,0.31695 h -0.008 v -0.37621 h -0.26734"
        id="path14678"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -330.47409,-316.60606 v -0.65594 h -0.26734 v 0.65594 h -0.38034 v 0.22462 h 0.38034 v 1.4938 c -0.003,0.18603 0.0317,0.31419 0.10197,0.38585 0.0703,0.0675 0.19431,0.10197 0.37345,0.10197 0.0386,0 0.0786,-0.001 0.11851,-0.006 0.0386,-0.003 0.0786,-0.004 0.11852,-0.004 v -0.22462 c -0.0772,0.01 -0.15297,0.0138 -0.22876,0.0138 -0.0965,-0.006 -0.15709,-0.0331 -0.1819,-0.0813 -0.0234,-0.0496 -0.0345,-0.11989 -0.0345,-0.20671 v -1.47312 h 0.44511 v -0.22462 h -0.44509"
        id="path14680"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -327.54438,-316.66945 c -0.16674,0 -0.31557,0.0303 -0.44511,0.0937 -0.12678,0.0606 -0.23426,0.14469 -0.32108,0.24942 -0.0882,0.10336 -0.15434,0.22738 -0.19982,0.36794 -0.0455,0.13781 -0.0675,0.28663 -0.0675,0.44373 0,0.15847 0.022,0.30868 0.0675,0.44924 0.0455,0.1378 0.11162,0.26045 0.19982,0.3638 0.0868,0.10473 0.1943,0.18741 0.32108,0.2508 0.12954,0.0593 0.27837,0.0882 0.44511,0.0882 0.16536,0 0.31281,-0.0289 0.43959,-0.0882 0.12954,-0.0634 0.2384,-0.14607 0.3266,-0.2508 0.0868,-0.10335 0.15296,-0.226 0.19843,-0.3638 0.0455,-0.14056 0.0675,-0.29077 0.0675,-0.44924 0,-0.1571 -0.0221,-0.30592 -0.0675,-0.44373 -0.0455,-0.14056 -0.11161,-0.26458 -0.19843,-0.36794 -0.0882,-0.10473 -0.19706,-0.18879 -0.3266,-0.24942 -0.12678,-0.0634 -0.27423,-0.0937 -0.43959,-0.0937 z m 0,0.22462 c 0.12678,0 0.2384,0.0262 0.33348,0.0799 0.0965,0.0537 0.17501,0.12402 0.2384,0.21222 0.0648,0.0868 0.11163,0.18741 0.14332,0.30041 0.0345,0.11024 0.051,0.22186 0.051,0.33762 0,0.11575 -0.0165,0.23151 -0.051,0.34313 -0.0317,0.11024 -0.0786,0.20946 -0.14332,0.29628 -0.0634,0.0882 -0.14193,0.15847 -0.2384,0.21222 -0.0951,0.0537 -0.2067,0.0799 -0.33348,0.0799 -0.12816,0 -0.2384,-0.0262 -0.33486,-0.0799 -0.0965,-0.0537 -0.17639,-0.12403 -0.24116,-0.21222 -0.062,-0.0868 -0.11025,-0.18604 -0.14332,-0.29628 -0.0317,-0.11162 -0.0469,-0.22738 -0.0469,-0.34313 0,-0.11576 0.0152,-0.22738 0.0469,-0.33762 0.0331,-0.113 0.0813,-0.2136 0.14332,-0.30041 0.0648,-0.0882 0.14469,-0.15848 0.24116,-0.21222 0.0965,-0.0538 0.2067,-0.0799 0.33486,-0.0799"
        id="path14682"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -325.272,-316.38144 v -0.22462 h -0.43132 v -0.19017 c 0,-0.0593 0.001,-0.11437 0.004,-0.16536 0.003,-0.051 0.0124,-0.0951 0.0303,-0.13091 0.0193,-0.04 0.0496,-0.0717 0.0882,-0.0937 0.04,-0.022 0.0965,-0.0331 0.1695,-0.0331 0.0303,0 0.062,10e-4 0.0937,0.008 0.0303,0.003 0.0648,0.007 0.1006,0.0124 v -0.22876 c -0.0413,-0.005 -0.0799,-0.01 -0.11438,-0.0124 -0.0331,-0.003 -0.0703,-0.004 -0.10887,-0.004 -0.10748,0 -0.19705,0.0152 -0.26733,0.0469 -0.0675,0.0303 -0.12127,0.0744 -0.16123,0.13091 -0.0386,0.0565 -0.0661,0.12403 -0.0799,0.20257 -0.0138,0.0799 -0.0207,0.16537 -0.0207,0.25907 v 0.19844 h -0.37344 v 0.22462 h 0.37344 v 1.95957 h 0.26597 v -1.95957 h 0.43132"
        id="path14684"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -321.58023,-316.53026 h 0.28801 c -0.0193,-0.15848 -0.0675,-0.29766 -0.14332,-0.41893 -0.0744,-0.12127 -0.16674,-0.22324 -0.27974,-0.30454 -0.11025,-0.0854 -0.23427,-0.14745 -0.37345,-0.19018 -0.13505,-0.0427 -0.27423,-0.0634 -0.41892,-0.0634 -0.23702,0 -0.44511,0.0427 -0.62563,0.13091 -0.17777,0.0841 -0.3266,0.19982 -0.44511,0.34726 -0.11851,0.14332 -0.2067,0.31006 -0.26596,0.49886 -0.0593,0.19016 -0.0896,0.3886 -0.0896,0.59668 0,0.20947 0.0303,0.4079 0.0896,0.5967 0.0593,0.19016 0.14745,0.35691 0.26596,0.50022 0.11851,0.14332 0.26734,0.26045 0.44511,0.34727 0.18052,0.0841 0.38861,0.12678 0.62563,0.12678 0.17777,0 0.339,-0.0275 0.48369,-0.0841 0.14607,-0.0565 0.27285,-0.13781 0.38034,-0.24116 0.10749,-0.10473 0.1943,-0.23151 0.26183,-0.38172 0.0689,-0.14882 0.11161,-0.31695 0.13229,-0.50436 h -0.28801 c -0.0138,0.13643 -0.0469,0.26321 -0.0978,0.38172 -0.051,0.11575 -0.11714,0.21773 -0.19844,0.30455 -0.0827,0.0882 -0.17915,0.15709 -0.29215,0.20808 -0.11299,0.0496 -0.23978,0.0758 -0.38171,0.0758 -0.19982,0 -0.37207,-0.0386 -0.51539,-0.11437 -0.14469,-0.0758 -0.2632,-0.17639 -0.35691,-0.30042 -0.0896,-0.12678 -0.1571,-0.27009 -0.20257,-0.42719 -0.0427,-0.16123 -0.0634,-0.32384 -0.0634,-0.48783 0,-0.16536 0.0207,-0.32797 0.0634,-0.48644 0.0455,-0.1571 0.113,-0.29904 0.20257,-0.42306 0.0937,-0.12678 0.21222,-0.22875 0.35691,-0.30455 0.14332,-0.0758 0.31557,-0.11437 0.51539,-0.11437 0.11024,0 0.21497,0.0165 0.31419,0.051 0.1006,0.0303 0.19293,0.0772 0.27423,0.13919 0.0854,0.062 0.15572,0.13918 0.21222,0.23288 0.0593,0.091 0.10197,0.19293 0.12678,0.30869"
        id="path14686"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -319.46357,-315.61525 v 0.34727 c 0,0.10748 -0.0207,0.20257 -0.0634,0.28801 -0.04,0.0841 -0.0951,0.15571 -0.16536,0.21497 -0.0675,0.0593 -0.14745,0.10473 -0.24116,0.13505 -0.0937,0.0317 -0.19017,0.0469 -0.29214,0.0469 -0.062,0 -0.12265,-0.01 -0.1819,-0.0289 -0.0593,-0.0193 -0.11162,-0.0482 -0.1571,-0.0841 -0.0441,-0.04 -0.0813,-0.0854 -0.11024,-0.13643 -0.0248,-0.0537 -0.0372,-0.11438 -0.0372,-0.1819 0,-0.10749 0.0303,-0.18879 0.0937,-0.24529 0.0648,-0.0593 0.14607,-0.10474 0.24529,-0.13643 0.0978,-0.0303 0.2067,-0.0524 0.32522,-0.0675 0.12126,-0.0166 0.2384,-0.0344 0.35139,-0.0538 0.0372,-0.007 0.0786,-0.0165 0.12679,-0.0303 0.0482,-0.0138 0.0813,-0.0372 0.0978,-0.0675 z m -1.42213,-0.32246 h 0.26734 c 0.005,-0.17777 0.0606,-0.30592 0.16812,-0.38447 0.10749,-0.0827 0.24529,-0.12265 0.41479,-0.12265 0.0799,0 0.15296,0.007 0.22048,0.0207 0.0703,0.011 0.13092,0.0344 0.18191,0.0675 0.0537,0.0345 0.0951,0.0813 0.12264,0.13918 0.0317,0.0565 0.0469,0.13091 0.0469,0.22049 0,0.0593 -0.008,0.10748 -0.0248,0.14469 -0.0138,0.0358 -0.0358,0.0661 -0.0634,0.0882 -0.0289,0.0207 -0.0648,0.0345 -0.10611,0.0427 -0.0427,0.008 -0.0923,0.0152 -0.14883,0.0207 -0.14332,0.0179 -0.28525,0.0358 -0.42719,0.0551 -0.13781,0.0179 -0.26459,0.0482 -0.37621,0.0937 -0.11024,0.0455 -0.19981,0.11163 -0.26734,0.19844 -0.0675,0.0854 -0.10197,0.20395 -0.10197,0.35554 0,0.11024 0.0193,0.2067 0.0551,0.28801 0.04,0.0785 0.0923,0.14607 0.1571,0.19843 0.0675,0.0524 0.14607,0.0882 0.23288,0.11163 0.0909,0.0248 0.18604,0.0372 0.28802,0.0372 0.10748,0 0.19843,-0.01 0.27422,-0.0289 0.0799,-0.0207 0.14883,-0.0482 0.20809,-0.0854 0.062,-0.0372 0.11713,-0.0813 0.16536,-0.13505 0.051,-0.0565 0.0992,-0.11989 0.14745,-0.19017 h 0.008 c 0,0.0551 0.003,0.10886 0.01,0.15572 0.008,0.0455 0.0234,0.0854 0.0455,0.11851 0.0234,0.0344 0.0538,0.0606 0.0937,0.0813 0.0427,0.0165 0.0978,0.0248 0.16537,0.0248 0.0358,0 0.0661,-0.001 0.0882,-0.004 0.0262,-0.003 0.0537,-0.007 0.0854,-0.0124 v -0.22462 c -0.0262,0.011 -0.0537,0.0165 -0.0854,0.0165 -0.10335,0 -0.15572,-0.0537 -0.15572,-0.16123 v -1.15893 c 0,-0.14746 -0.0248,-0.26596 -0.073,-0.35554 -0.0469,-0.0937 -0.11025,-0.16536 -0.18604,-0.21635 -0.0758,-0.051 -0.16261,-0.0841 -0.25769,-0.10197 -0.0965,-0.0193 -0.19155,-0.0289 -0.28801,-0.0289 -0.12678,0 -0.24254,0.0138 -0.34727,0.0413 -0.10473,0.0289 -0.19568,0.073 -0.27561,0.13229 -0.0758,0.0593 -0.13642,0.13505 -0.1819,0.22875 -0.0455,0.0923 -0.0717,0.20258 -0.0799,0.32935"
        id="path14688"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -318.23987,-316.60606 v -0.65594 h -0.26734 v 0.65594 h -0.38034 v 0.22462 h 0.38034 v 1.4938 c -0.003,0.18603 0.0317,0.31419 0.10198,0.38585 0.0703,0.0675 0.1943,0.10197 0.37345,0.10197 0.0386,0 0.0785,-0.001 0.11851,-0.006 0.0386,-0.003 0.0785,-0.004 0.11713,-0.004 v -0.22462 c -0.0758,0.01 -0.15159,0.0138 -0.22738,0.0138 -0.0965,-0.006 -0.15709,-0.0331 -0.18327,-0.0813 -0.022,-0.0496 -0.0331,-0.11989 -0.0331,-0.20671 v -1.47312 h 0.44373 v -0.22462 h -0.44373"
        id="path14690"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -316.01296,-315.61525 v 0.34727 c 0,0.10748 -0.022,0.20257 -0.0634,0.28801 -0.04,0.0841 -0.0951,0.15571 -0.16536,0.21497 -0.0675,0.0593 -0.14883,0.10473 -0.24116,0.13505 -0.0937,0.0317 -0.19155,0.0469 -0.29214,0.0469 -0.062,0 -0.12265,-0.01 -0.1819,-0.0289 -0.0593,-0.0193 -0.11163,-0.0482 -0.1571,-0.0841 -0.0455,-0.04 -0.0813,-0.0854 -0.11025,-0.13643 -0.0248,-0.0537 -0.0386,-0.11438 -0.0386,-0.1819 0,-0.10749 0.0317,-0.18879 0.0937,-0.24529 0.0648,-0.0593 0.14745,-0.10474 0.24529,-0.13643 0.0992,-0.0303 0.20808,-0.0524 0.32659,-0.0675 0.12127,-0.0166 0.2384,-0.0344 0.3514,-0.0538 0.0358,-0.007 0.0786,-0.0165 0.12678,-0.0303 0.0482,-0.0138 0.0799,-0.0372 0.0978,-0.0675 z m -1.42213,-0.32246 h 0.26596 c 0.005,-0.17777 0.062,-0.30592 0.1695,-0.38447 0.10748,-0.0827 0.24529,-0.12265 0.41478,-0.12265 0.0786,0 0.15297,0.007 0.22049,0.0207 0.0703,0.011 0.13092,0.0344 0.1819,0.0675 0.0537,0.0345 0.0937,0.0813 0.12265,0.13918 0.0303,0.0565 0.0469,0.13091 0.0469,0.22049 0,0.0593 -0.008,0.10748 -0.0262,0.14469 -0.0138,0.0358 -0.0345,0.0661 -0.0634,0.0882 -0.0276,0.0207 -0.0634,0.0345 -0.10611,0.0427 -0.0413,0.008 -0.0909,0.0152 -0.14745,0.0207 -0.1447,0.0179 -0.28664,0.0358 -0.4272,0.0551 -0.13918,0.0179 -0.26458,0.0482 -0.37758,0.0937 -0.11024,0.0455 -0.19844,0.11163 -0.26596,0.19844 -0.0689,0.0854 -0.10197,0.20395 -0.10197,0.35554 0,0.11024 0.0179,0.2067 0.0551,0.28801 0.04,0.0785 0.091,0.14607 0.15709,0.19843 0.0675,0.0524 0.1447,0.0882 0.23151,0.11163 0.091,0.0248 0.18742,0.0372 0.28801,0.0372 0.10749,0 0.19982,-0.01 0.27561,-0.0289 0.0786,-0.0207 0.14883,-0.0482 0.20808,-0.0854 0.062,-0.0372 0.11714,-0.0813 0.16399,-0.13505 0.051,-0.0565 0.1006,-0.11989 0.14883,-0.19017 h 0.008 c 0,0.0551 0.003,0.10886 0.008,0.15572 0.008,0.0455 0.0248,0.0854 0.0469,0.11851 0.022,0.0344 0.0537,0.0606 0.0937,0.0813 0.0413,0.0165 0.0965,0.0248 0.16399,0.0248 0.0372,0 0.0675,-0.001 0.0896,-0.004 0.0248,-0.003 0.0537,-0.007 0.0841,-0.0124 v -0.22462 c -0.0248,0.011 -0.0538,0.0165 -0.0841,0.0165 -0.10473,0 -0.1571,-0.0537 -0.1571,-0.16123 v -1.15893 c 0,-0.14746 -0.0234,-0.26596 -0.0717,-0.35554 -0.0482,-0.0937 -0.11024,-0.16536 -0.18603,-0.21635 -0.0758,-0.051 -0.16261,-0.0841 -0.25907,-0.10197 -0.0951,-0.0193 -0.19155,-0.0289 -0.28663,-0.0289 -0.12816,0 -0.24392,0.0138 -0.34727,0.0413 -0.10473,0.0289 -0.19706,0.073 -0.27561,0.13229 -0.0758,0.0593 -0.13642,0.13505 -0.1819,0.22875 -0.0455,0.0923 -0.0717,0.20258 -0.0799,0.32935"
        id="path14692"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -315.20956,-317.44391 v 3.02204 h 0.26734 v -3.02204 h -0.26734"
        id="path14694"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -313.50769,-316.66945 c -0.16674,0 -0.31419,0.0303 -0.44372,0.0937 -0.12678,0.0606 -0.23427,0.14469 -0.32247,0.24942 -0.0868,0.10336 -0.15296,0.22738 -0.19843,0.36794 -0.0455,0.13781 -0.0675,0.28663 -0.0675,0.44373 0,0.15847 0.0221,0.30868 0.0675,0.44924 0.0455,0.1378 0.11162,0.26045 0.19843,0.3638 0.0882,0.10473 0.19569,0.18741 0.32247,0.2508 0.12953,0.0593 0.27698,0.0882 0.44372,0.0882 0.16675,0 0.3142,-0.0289 0.44098,-0.0882 0.12953,-0.0634 0.2384,-0.14607 0.32521,-0.2508 0.0882,-0.10335 0.15434,-0.226 0.19982,-0.3638 0.0455,-0.14056 0.0675,-0.29077 0.0675,-0.44924 0,-0.1571 -0.022,-0.30592 -0.0675,-0.44373 -0.0455,-0.14056 -0.11162,-0.26458 -0.19982,-0.36794 -0.0868,-0.10473 -0.19568,-0.18879 -0.32521,-0.24942 -0.12678,-0.0634 -0.27423,-0.0937 -0.44098,-0.0937 z m 0,0.22462 c 0.12678,0 0.2384,0.0262 0.33487,0.0799 0.0965,0.0537 0.17501,0.12402 0.23702,0.21222 0.0648,0.0868 0.113,0.18741 0.14332,0.30041 0.0345,0.11024 0.051,0.22186 0.051,0.33762 0,0.11575 -0.0165,0.23151 -0.051,0.34313 -0.0303,0.11024 -0.0786,0.20946 -0.14332,0.29628 -0.062,0.0882 -0.14056,0.15847 -0.23702,0.21222 -0.0965,0.0537 -0.20809,0.0799 -0.33487,0.0799 -0.12678,0 -0.2384,-0.0262 -0.33348,-0.0799 -0.0965,-0.0537 -0.17639,-0.12403 -0.24116,-0.21222 -0.0634,-0.0868 -0.11024,-0.18604 -0.14469,-0.29628 -0.0303,-0.11162 -0.0469,-0.22738 -0.0469,-0.34313 0,-0.11576 0.0165,-0.22738 0.0469,-0.33762 0.0345,-0.113 0.0813,-0.2136 0.14469,-0.30041 0.0648,-0.0882 0.1447,-0.15848 0.24116,-0.21222 0.0951,-0.0538 0.2067,-0.0799 0.33348,-0.0799"
        id="path14696"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -312.08004,-316.60606 v 2.18419 h 0.26596 v -1.27331 c 0.003,-0.10748 0.0193,-0.2067 0.051,-0.29765 0.0345,-0.0923 0.0785,-0.17088 0.13505,-0.23702 0.0593,-0.0675 0.12953,-0.11989 0.21222,-0.15572 0.0841,-0.04 0.18052,-0.0593 0.28801,-0.0593 0.10748,0 0.19568,0.0166 0.26596,0.0496 0.0744,0.0345 0.13229,0.0813 0.17363,0.14056 0.0427,0.0593 0.0717,0.12954 0.0896,0.21084 0.0165,0.0799 0.0248,0.16537 0.0248,0.25907 v 1.36288 h 0.26734 v -1.4056 c 0,-0.12953 -0.0124,-0.24666 -0.0386,-0.3514 -0.0248,-0.10335 -0.0689,-0.19154 -0.13091,-0.26182 -0.062,-0.0744 -0.14607,-0.12954 -0.24942,-0.1695 -0.10198,-0.04 -0.22876,-0.0593 -0.38172,-0.0593 -0.15434,0 -0.29766,0.0413 -0.42719,0.12265 -0.12954,0.0786 -0.22049,0.18466 -0.27147,0.31695 h -0.008 v -0.37621 h -0.26596"
        id="path14698"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -309.79938,-316.60606 v 2.18419 h 0.26733 v -2.18419 z m 0,-0.83785 v 0.4272 h 0.26733 v -0.4272 h -0.26733"
        id="path14700"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -307.62346,-315.61525 v 0.34727 c 0,0.10748 -0.0207,0.20257 -0.0634,0.28801 -0.0386,0.0841 -0.0937,0.15571 -0.16399,0.21497 -0.0689,0.0593 -0.14883,0.10473 -0.24253,0.13505 -0.0923,0.0317 -0.19017,0.0469 -0.29215,0.0469 -0.062,0 -0.12264,-0.01 -0.1819,-0.0289 -0.0592,-0.0193 -0.11162,-0.0482 -0.15572,-0.0841 -0.0455,-0.04 -0.0827,-0.0854 -0.11024,-0.13643 -0.0262,-0.0537 -0.0386,-0.11438 -0.0386,-0.1819 0,-0.10749 0.0317,-0.18879 0.0937,-0.24529 0.0648,-0.0593 0.14607,-0.10474 0.24529,-0.13643 0.0992,-0.0303 0.20671,-0.0524 0.32522,-0.0675 0.12264,-0.0166 0.23978,-0.0344 0.3514,-0.0538 0.0372,-0.007 0.0799,-0.0165 0.12816,-0.0303 0.0469,-0.0138 0.0799,-0.0372 0.0965,-0.0675 z m -1.42214,-0.32246 h 0.26734 c 0.006,-0.17777 0.062,-0.30592 0.1695,-0.38447 0.10611,-0.0827 0.24529,-0.12265 0.41479,-0.12265 0.0786,0 0.15159,0.007 0.21911,0.0207 0.0717,0.011 0.13229,0.0344 0.18328,0.0675 0.0524,0.0345 0.0937,0.0813 0.12264,0.13918 0.0303,0.0565 0.0455,0.13091 0.0455,0.22049 0,0.0593 -0.008,0.10748 -0.0248,0.14469 -0.0138,0.0358 -0.0358,0.0661 -0.0634,0.0882 -0.0289,0.0207 -0.0634,0.0345 -0.10611,0.0427 -0.0427,0.008 -0.0909,0.0152 -0.14745,0.0207 -0.14469,0.0179 -0.28663,0.0358 -0.42857,0.0551 -0.1378,0.0179 -0.2632,0.0482 -0.3762,0.0937 -0.11025,0.0455 -0.19844,0.11163 -0.26734,0.19844 -0.0675,0.0854 -0.1006,0.20395 -0.1006,0.35554 0,0.11024 0.0179,0.2067 0.0551,0.28801 0.0386,0.0785 0.091,0.14607 0.15572,0.19843 0.0675,0.0524 0.14607,0.0882 0.23289,0.11163 0.0909,0.0248 0.18603,0.0372 0.28801,0.0372 0.10748,0 0.19844,-0.01 0.27561,-0.0289 0.0785,-0.0207 0.14745,-0.0482 0.2067,-0.0854 0.062,-0.0372 0.11714,-0.0813 0.16537,-0.13505 0.051,-0.0565 0.10059,-0.11989 0.14883,-0.19017 h 0.008 c 0,0.0551 0.003,0.10886 0.008,0.15572 0.008,0.0455 0.0234,0.0854 0.0469,0.11851 0.022,0.0344 0.0537,0.0606 0.0923,0.0813 0.0427,0.0165 0.0978,0.0248 0.16536,0.0248 0.0372,0 0.0661,-0.001 0.0896,-0.004 0.0248,-0.003 0.0537,-0.007 0.0841,-0.0124 v -0.22462 c -0.0248,0.011 -0.0537,0.0165 -0.0841,0.0165 -0.10473,0 -0.1571,-0.0537 -0.1571,-0.16123 v -1.15893 c 0,-0.14746 -0.0234,-0.26596 -0.0717,-0.35554 -0.0482,-0.0937 -0.11024,-0.16536 -0.18603,-0.21635 -0.0772,-0.051 -0.16261,-0.0841 -0.25907,-0.10197 -0.0951,-0.0193 -0.19155,-0.0289 -0.28801,-0.0289 -0.12679,0 -0.24254,0.0138 -0.34727,0.0413 -0.10335,0.0289 -0.19568,0.073 -0.27423,0.13229 -0.0772,0.0593 -0.1378,0.13505 -0.1819,0.22875 -0.0455,0.0923 -0.073,0.20258 -0.0813,0.32935"
        id="path14702"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -350.03121,-320.7512 c -0.0482,-0.20808 -0.16674,-0.35278 -0.35416,-0.43684 -0.10472,-0.0455 -0.22048,-0.0675 -0.34864,-0.0675 -0.24529,0 -0.44786,0.0937 -0.60634,0.27974 -0.15709,0.18466 -0.23564,0.46302 -0.23564,0.83509 0,0.37483 0.0854,0.63941 0.25632,0.79513 0.17087,0.15572 0.36517,0.23289 0.58291,0.23289 0.21359,0 0.3886,-0.0606 0.52503,-0.18328 0.13642,-0.12402 0.22048,-0.28525 0.25218,-0.48507 h -0.70418 v -0.50849 h 1.26918 v 1.63435 h -0.42169 l -0.0648,-0.38034 c -0.12265,0.14469 -0.23289,0.24667 -0.33073,0.30592 -0.16812,0.10336 -0.37483,0.15572 -0.62012,0.15572 -0.40376,0 -0.73449,-0.14056 -0.99219,-0.4203 -0.26871,-0.28112 -0.40238,-0.66559 -0.40238,-1.15342 0,-0.49333 0.13505,-0.88883 0.40652,-1.18649 0.27147,-0.29765 0.63114,-0.44648 1.07762,-0.44648 0.38723,0 0.69729,0.0992 0.93156,0.29628 0.23564,0.19568 0.37069,0.43959 0.40514,0.73311 h -0.62563"
        id="path14704"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -347.43912,-320.86282 c 0.15021,0.0703 0.27423,0.1819 0.37207,0.33349 0.0882,0.13367 0.1447,0.28801 0.17088,0.4644 0.0152,0.10335 0.022,0.25218 0.0193,0.44648 h -1.54203 c 0.008,0.226 0.0786,0.38447 0.21222,0.47543 0.0813,0.0565 0.17914,0.0854 0.29352,0.0854 0.12127,0 0.22049,-0.0344 0.29628,-0.10473 0.0413,-0.0358 0.0772,-0.0882 0.10886,-0.15434 h 0.6022 c -0.0152,0.13367 -0.0854,0.2701 -0.20946,0.4079 -0.19292,0.21911 -0.46302,0.32797 -0.81028,0.32797 -0.28663,0 -0.53881,-0.0923 -0.75792,-0.27698 -0.21911,-0.18466 -0.32935,-0.48507 -0.32935,-0.90124 0,-0.38999 0.0992,-0.68902 0.29627,-0.8971 0.19844,-0.20809 0.45475,-0.31144 0.77033,-0.31281 0.18741,0 0.35691,0.0358 0.50712,0.1061 z m -0.82544,0.5085 c -0.0744,0.0854 -0.12127,0.20119 -0.14057,0.34726 h 0.9164 c -0.01,-0.15571 -0.0579,-0.27285 -0.14331,-0.35277 -0.0841,-0.0813 -0.1888,-0.12265 -0.3142,-0.12265 -0.13642,0 -0.24253,0.0427 -0.31832,0.12816"
        id="path14706"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -344.66099,-320.77738 c 0.14882,0.12127 0.22324,0.32246 0.22324,0.60496 v 1.51722 h -0.60358 v -1.36977 c 0,-0.11851 -0.0165,-0.20946 -0.0482,-0.27285 -0.0579,-0.11576 -0.16812,-0.17364 -0.33073,-0.17364 -0.19982,0 -0.33624,0.0841 -0.41066,0.25356 -0.0386,0.0896 -0.0579,0.20396 -0.0579,0.34314 v 1.21956 h -0.58704 v -2.24896 h 0.56775 v 0.32935 c 0.0758,-0.11575 0.14745,-0.19981 0.21497,-0.2508 0.12127,-0.091 0.27561,-0.13643 0.46165,-0.13643 0.23288,0 0.42306,0.062 0.57051,0.18466"
        id="path14708"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -342.49885,-320.86282 c 0.1502,0.0703 0.27423,0.1819 0.37207,0.33349 0.0882,0.13367 0.14469,0.28801 0.17087,0.4644 0.0152,0.10335 0.0221,0.25218 0.0193,0.44648 h -1.54202 c 0.008,0.226 0.0785,0.38447 0.21221,0.47543 0.0813,0.0565 0.17915,0.0854 0.29353,0.0854 0.12126,0 0.22048,-0.0344 0.29628,-0.10473 0.0413,-0.0358 0.0772,-0.0882 0.10886,-0.15434 h 0.6022 c -0.0152,0.13367 -0.0854,0.2701 -0.20946,0.4079 -0.19292,0.21911 -0.46302,0.32797 -0.81028,0.32797 -0.28664,0 -0.53882,-0.0923 -0.75793,-0.27698 -0.21911,-0.18466 -0.32935,-0.48507 -0.32935,-0.90124 0,-0.38999 0.0992,-0.68902 0.29628,-0.8971 0.19844,-0.20809 0.45475,-0.31144 0.77032,-0.31281 0.18742,0 0.35691,0.0358 0.50712,0.1061 z m -0.82545,0.5085 c -0.0744,0.0854 -0.12126,0.20119 -0.14056,0.34726 h 0.9164 c -0.01,-0.15571 -0.0579,-0.27285 -0.14332,-0.35277 -0.0841,-0.0813 -0.18879,-0.12265 -0.31419,-0.12265 -0.13643,0 -0.24254,0.0427 -0.31833,0.12816"
        id="path14710"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -340.28986,-320.95928 c 0.008,0 0.0262,0 0.0524,10e-4 v 0.60358 c -0.0372,-0.004 -0.0703,-0.007 -0.0992,-0.008 -0.0289,-10e-4 -0.0524,-10e-4 -0.0703,-10e-4 -0.23702,0 -0.39688,0.0772 -0.47818,0.23151 -0.0455,0.0868 -0.0675,0.22049 -0.0675,0.39963 v 1.07763 h -0.59393 v -2.25309 h 0.56224 v 0.39274 c 0.091,-0.15021 0.17088,-0.25218 0.2384,-0.3073 0.11024,-0.0923 0.25356,-0.13918 0.42995,-0.13918 0.011,0 0.0193,0.001 0.0262,0.003"
        id="path14712"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -339.00828,-320.02497 c 0.10886,-0.0138 0.18741,-0.0317 0.23427,-0.0524 0.0841,-0.0358 0.12539,-0.091 0.12539,-0.16674 0,-0.0923 -0.0317,-0.15572 -0.0965,-0.19155 -0.0634,-0.0344 -0.15709,-0.0524 -0.28112,-0.0524 -0.13918,0 -0.2384,0.0344 -0.29627,0.10335 -0.0413,0.051 -0.0689,0.11989 -0.0827,0.20671 h -0.56775 c 0.0124,-0.19706 0.0675,-0.35967 0.16537,-0.48645 0.15571,-0.19844 0.42306,-0.29766 0.80202,-0.29766 0.24666,0 0.46577,0.0496 0.65732,0.14608 0.19155,0.0992 0.28663,0.28387 0.28663,0.55397 v 1.03353 c 0,0.073 0.001,0.15985 0.004,0.26182 0.004,0.0772 0.0165,0.12954 0.0358,0.1571 0.0193,0.0276 0.0482,0.0496 0.0868,0.0675 v 0.0868 h -0.64078 c -0.0179,-0.0455 -0.0303,-0.0882 -0.0372,-0.12816 -0.007,-0.04 -0.0124,-0.0854 -0.0165,-0.13642 -0.0813,0.0882 -0.17501,0.16398 -0.28111,0.22599 -0.12679,0.073 -0.2701,0.10887 -0.42995,0.10887 -0.20395,0 -0.37345,-0.0579 -0.50712,-0.17363 -0.13229,-0.11714 -0.19844,-0.2825 -0.19844,-0.4961 0,-0.27698 0.10749,-0.47818 0.32108,-0.60082 0.11714,-0.0675 0.28939,-0.11576 0.51677,-0.1447 z m 0.35829,0.27423 c -0.0372,0.0234 -0.0758,0.0427 -0.11438,0.0579 -0.0372,0.0138 -0.0882,0.0262 -0.15434,0.04 l -0.13229,0.0248 c -0.12402,0.0221 -0.2136,0.0482 -0.26734,0.0799 -0.091,0.0537 -0.13643,0.13781 -0.13643,0.25081 0,0.10059 0.0276,0.17363 0.0827,0.2191 0.0565,0.0441 0.1254,0.0661 0.20532,0.0661 0.12678,0 0.24254,-0.0386 0.34865,-0.11162 0.10748,-0.0744 0.16398,-0.21084 0.16812,-0.4079 v -0.21911"
        id="path14714"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -336.93709,-318.6552 h -0.58842 v -3.04684 h 0.58842 v 3.04684"
        id="path14716"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -336.35418,-320.90829 h 0.59807 v 2.25309 h -0.59807 z m 0.59807,-0.26872 h -0.59807 v -0.54295 h 0.59807 v 0.54295"
        id="path14718"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -335.41711,-320.46732 v -0.4203 h 0.31419 v -0.62839 h 0.58291 v 0.62839 h 0.36518 v 0.4203 h -0.36518 v 1.19062 c 0,0.0923 0.011,0.15021 0.0345,0.17364 0.0234,0.0221 0.0951,0.0317 0.21497,0.0317 0.0179,0 0.0372,0 0.0565,0 0.0207,0 0.04,-10e-4 0.0593,-0.003 v 0.43959 l -0.27836,0.011 c -0.27836,0.008 -0.46853,-0.0386 -0.57051,-0.14469 -0.0661,-0.0675 -0.0992,-0.17225 -0.0992,-0.31281 v -1.38631 h -0.31419"
        id="path14720"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -332.89117,-320.02497 c 0.10886,-0.0138 0.18603,-0.0317 0.23289,-0.0524 0.0841,-0.0358 0.12678,-0.091 0.12678,-0.16674 0,-0.0923 -0.0331,-0.15572 -0.0978,-0.19155 -0.0634,-0.0344 -0.1571,-0.0524 -0.28112,-0.0524 -0.13918,0 -0.23703,0.0344 -0.2949,0.10335 -0.0414,0.051 -0.0689,0.11989 -0.0827,0.20671 h -0.56913 c 0.0124,-0.19706 0.0675,-0.35967 0.16536,-0.48645 0.15572,-0.19844 0.42306,-0.29766 0.80202,-0.29766 0.24667,0 0.46578,0.0496 0.65732,0.14608 0.19155,0.0992 0.28801,0.28387 0.28801,0.55397 v 1.03353 c 0,0.073 10e-4,0.15985 0.004,0.26182 0.004,0.0772 0.0152,0.12954 0.0345,0.1571 0.0193,0.0276 0.0482,0.0496 0.0868,0.0675 v 0.0868 h -0.64079 c -0.0179,-0.0455 -0.0303,-0.0882 -0.0372,-0.12816 -0.007,-0.04 -0.0124,-0.0854 -0.0165,-0.13642 -0.0813,0.0882 -0.17501,0.16398 -0.28112,0.22599 -0.12678,0.073 -0.2701,0.10887 -0.42995,0.10887 -0.20395,0 -0.37207,-0.0579 -0.50574,-0.17363 -0.13229,-0.11714 -0.19844,-0.2825 -0.19844,-0.4961 0,-0.27698 0.10611,-0.47818 0.31971,-0.60082 0.11713,-0.0675 0.28939,-0.11576 0.51676,-0.1447 z m 0.35691,0.27423 c -0.0372,0.0234 -0.0744,0.0427 -0.113,0.0579 -0.0372,0.0138 -0.0896,0.0262 -0.15571,0.04 l -0.1323,0.0248 c -0.12402,0.0221 -0.21222,0.0482 -0.26596,0.0799 -0.0909,0.0537 -0.13643,0.13781 -0.13643,0.25081 0,0.10059 0.0276,0.17363 0.0827,0.2191 0.0565,0.0441 0.12402,0.0661 0.20395,0.0661 0.12678,0 0.24391,-0.0386 0.35002,-0.11162 0.10749,-0.0744 0.16261,-0.21084 0.16674,-0.4079 v -0.21911"
        id="path14722"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -331.65369,-320.46732 v -0.4203 h 0.31419 v -0.62839 h 0.58291 v 0.62839 h 0.36656 v 0.4203 h -0.36656 v 1.19062 c 0,0.0923 0.0124,0.15021 0.0358,0.17364 0.0234,0.0221 0.0951,0.0317 0.21498,0.0317 0.0179,0 0.0358,0 0.0551,0 0.0207,0 0.0413,-10e-4 0.0606,-0.003 v 0.43959 l -0.27974,0.011 c -0.27837,0.008 -0.46853,-0.0386 -0.57051,-0.14469 -0.0661,-0.0675 -0.0992,-0.17225 -0.0992,-0.31281 v -1.38631 h -0.31419"
        id="path14724"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -327.49615,-319.26705 c 0.0868,-0.12402 0.12953,-0.28387 0.12953,-0.48094 0,-0.2756 -0.0689,-0.47266 -0.20808,-0.59117 -0.0854,-0.0717 -0.18466,-0.10749 -0.29766,-0.10749 -0.17225,0 -0.29903,0.0648 -0.38034,0.19568 -0.0799,0.12954 -0.11988,0.29077 -0.11988,0.48369 0,0.20809 0.04,0.37483 0.12126,0.50023 0.0827,0.12403 0.20809,0.18604 0.37483,0.18604 0.16674,0 0.29352,-0.062 0.38034,-0.18604 z m -0.14469,-1.60404 c 0.1061,0.0593 0.19154,0.14194 0.25769,0.24805 v -1.07487 h 0.59807 v 3.04271 h -0.57327 v -0.31144 c -0.0841,0.13367 -0.17914,0.23014 -0.28663,0.29077 -0.10749,0.0606 -0.24115,0.0909 -0.40101,0.0909 -0.2632,0 -0.48507,-0.10611 -0.66559,-0.31833 -0.17915,-0.21359 -0.26872,-0.48644 -0.26872,-0.81993 0,-0.38585 0.0882,-0.68764 0.26458,-0.90813 0.17777,-0.22048 0.4148,-0.33073 0.71107,-0.33073 0.13643,0 0.2577,0.0303 0.36381,0.091"
        id="path14726"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -324.85445,-320.86282 c 0.15021,0.0703 0.27423,0.1819 0.37207,0.33349 0.0882,0.13367 0.14469,0.28801 0.17088,0.4644 0.0152,0.10335 0.022,0.25218 0.0193,0.44648 h -1.54202 c 0.008,0.226 0.0786,0.38447 0.21222,0.47543 0.0813,0.0565 0.17914,0.0854 0.29352,0.0854 0.12127,0 0.22048,-0.0344 0.29627,-0.10473 0.0414,-0.0358 0.0772,-0.0882 0.10887,-0.15434 h 0.6022 c -0.0152,0.13367 -0.0854,0.2701 -0.20946,0.4079 -0.19292,0.21911 -0.46302,0.32797 -0.81029,0.32797 -0.28663,0 -0.53881,-0.0923 -0.75792,-0.27698 -0.2191,-0.18466 -0.32935,-0.48507 -0.32935,-0.90124 0,-0.38999 0.0992,-0.68902 0.29628,-0.8971 0.19844,-0.20809 0.45475,-0.31144 0.77032,-0.31281 0.18742,0 0.35692,0.0358 0.50712,0.1061 z m -0.82545,0.5085 c -0.0744,0.0854 -0.12126,0.20119 -0.14055,0.34726 h 0.91639 c -0.01,-0.15571 -0.0579,-0.27285 -0.14332,-0.35277 -0.0841,-0.0813 -0.18879,-0.12265 -0.31419,-0.12265 -0.13642,0 -0.24253,0.0427 -0.31833,0.12816"
        id="path14728"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -322.37674,-321.38372 c 0.24805,-0.2508 0.56362,-0.3762 0.94671,-0.3762 0.51263,0 0.88746,0.16812 1.12448,0.50436 0.13092,0.18879 0.2012,0.37758 0.21084,0.56913 h -0.63665 c -0.0413,-0.14607 -0.0937,-0.25632 -0.15848,-0.33073 -0.11575,-0.13229 -0.28801,-0.19843 -0.51538,-0.19843 -0.23151,0 -0.41341,0.0937 -0.54708,0.28111 -0.13367,0.18466 -0.2012,0.44925 -0.2012,0.791 0,0.34175 0.0703,0.59807 0.21084,0.76894 0.14194,0.1695 0.32247,0.25494 0.54019,0.25494 0.22325,0 0.39274,-0.073 0.50988,-0.21911 0.0648,-0.0786 0.11851,-0.19706 0.16123,-0.35415 h 0.63114 c -0.0551,0.3321 -0.19706,0.6022 -0.42444,0.81028 -0.22599,0.20809 -0.51538,0.31144 -0.86954,0.31282 -0.43822,0 -0.78272,-0.14056 -1.03353,-0.42168 -0.2508,-0.2825 -0.3762,-0.66973 -0.3762,-1.16307 0,-0.53054 0.14194,-0.9412 0.42719,-1.22921"
        id="path14730"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -318.7773,-320.02497 c 0.10886,-0.0138 0.18603,-0.0317 0.23289,-0.0524 0.0841,-0.0358 0.12677,-0.091 0.12677,-0.16674 0,-0.0923 -0.0331,-0.15572 -0.0978,-0.19155 -0.0634,-0.0344 -0.1571,-0.0524 -0.28113,-0.0524 -0.13918,0 -0.23702,0.0344 -0.2949,0.10335 -0.0413,0.051 -0.0689,0.11989 -0.0827,0.20671 h -0.56913 c 0.0124,-0.19706 0.0675,-0.35967 0.16537,-0.48645 0.15571,-0.19844 0.42306,-0.29766 0.80202,-0.29766 0.24666,0 0.46577,0.0496 0.65732,0.14608 0.19155,0.0992 0.28801,0.28387 0.28801,0.55397 v 1.03353 c 0,0.073 10e-4,0.15985 0.004,0.26182 0.004,0.0772 0.0152,0.12954 0.0345,0.1571 0.0193,0.0276 0.0482,0.0496 0.0868,0.0675 v 0.0868 h -0.64079 c -0.0179,-0.0455 -0.0303,-0.0882 -0.0372,-0.12816 -0.007,-0.04 -0.0124,-0.0854 -0.0165,-0.13642 -0.0813,0.0882 -0.17501,0.16398 -0.28112,0.22599 -0.12678,0.073 -0.2701,0.10887 -0.42995,0.10887 -0.20395,0 -0.37207,-0.0579 -0.50574,-0.17363 -0.13229,-0.11714 -0.19844,-0.2825 -0.19844,-0.4961 0,-0.27698 0.10611,-0.47818 0.31971,-0.60082 0.11713,-0.0675 0.28939,-0.11576 0.51676,-0.1447 z m 0.35691,0.27423 c -0.0372,0.0234 -0.0744,0.0427 -0.113,0.0579 -0.0372,0.0138 -0.0896,0.0262 -0.15572,0.04 l -0.13229,0.0248 c -0.12402,0.0221 -0.21222,0.0482 -0.26596,0.0799 -0.091,0.0537 -0.13643,0.13781 -0.13643,0.25081 0,0.10059 0.0276,0.17363 0.0827,0.2191 0.0565,0.0441 0.12403,0.0661 0.20395,0.0661 0.12678,0 0.24392,-0.0386 0.35003,-0.11162 0.10748,-0.0744 0.1626,-0.21084 0.16674,-0.4079 v -0.21911"
        id="path14732"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -317.53983,-320.46732 v -0.4203 h 0.3142 v -0.62839 h 0.58291 v 0.62839 h 0.36655 v 0.4203 h -0.36655 v 1.19062 c 0,0.0923 0.0124,0.15021 0.0358,0.17364 0.0234,0.0221 0.0951,0.0317 0.21497,0.0317 0.0179,0 0.0358,0 0.0551,0 0.0207,0 0.0413,-10e-4 0.0606,-0.003 v 0.43959 l -0.27974,0.011 c -0.27836,0.008 -0.46853,-0.0386 -0.5705,-0.14469 -0.0661,-0.0675 -0.0992,-0.17225 -0.0992,-0.31281 v -1.38631 h -0.3142"
        id="path14734"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -315.01388,-320.02497 c 0.10886,-0.0138 0.18741,-0.0317 0.23427,-0.0524 0.0841,-0.0358 0.1254,-0.091 0.1254,-0.16674 0,-0.0923 -0.0317,-0.15572 -0.0965,-0.19155 -0.0634,-0.0344 -0.15709,-0.0524 -0.28111,-0.0524 -0.13919,0 -0.2384,0.0344 -0.29628,0.10335 -0.0413,0.051 -0.0689,0.11989 -0.0827,0.20671 h -0.56775 c 0.0124,-0.19706 0.0675,-0.35967 0.16537,-0.48645 0.15572,-0.19844 0.42305,-0.29766 0.80201,-0.29766 0.24667,0 0.46578,0.0496 0.65733,0.14608 0.19155,0.0992 0.28663,0.28387 0.28663,0.55397 v 1.03353 c 0,0.073 10e-4,0.15985 0.004,0.26182 0.004,0.0772 0.0165,0.12954 0.0358,0.1571 0.0193,0.0276 0.0482,0.0496 0.0868,0.0675 v 0.0868 h -0.64078 c -0.0179,-0.0455 -0.0303,-0.0882 -0.0372,-0.12816 -0.007,-0.04 -0.0124,-0.0854 -0.0165,-0.13642 -0.0813,0.0882 -0.17501,0.16398 -0.28112,0.22599 -0.12678,0.073 -0.27009,0.10887 -0.42995,0.10887 -0.20394,0 -0.37344,-0.0579 -0.50711,-0.17363 -0.1323,-0.11714 -0.19844,-0.2825 -0.19844,-0.4961 0,-0.27698 0.10749,-0.47818 0.32108,-0.60082 0.11713,-0.0675 0.28939,-0.11576 0.51677,-0.1447 z m 0.35829,0.27423 c -0.0372,0.0234 -0.0758,0.0427 -0.11438,0.0579 -0.0372,0.0138 -0.0882,0.0262 -0.15434,0.04 l -0.13229,0.0248 c -0.12402,0.0221 -0.21359,0.0482 -0.26734,0.0799 -0.091,0.0537 -0.13643,0.13781 -0.13643,0.25081 0,0.10059 0.0276,0.17363 0.0827,0.2191 0.0565,0.0441 0.1254,0.0661 0.20532,0.0661 0.12678,0 0.24254,-0.0386 0.34865,-0.11162 0.10749,-0.0744 0.16398,-0.21084 0.16812,-0.4079 v -0.21911"
        id="path14736"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -312.94269,-318.6552 h -0.58842 v -3.04684 h 0.58842 v 3.04684"
        id="path14738"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -311.781,-320.90829 v 1.35874 c 0,0.12678 0.0152,0.22462 0.0455,0.28939 0.0537,0.11438 0.15985,0.17088 0.31695,0.17088 0.2012,0 0.339,-0.0813 0.41341,-0.24392 0.0386,-0.0882 0.0579,-0.20394 0.0579,-0.34864 v -1.22645 h 0.59669 v 2.25309 h -0.57189 v -0.31833 c -0.006,0.007 -0.0193,0.0276 -0.0413,0.062 -0.022,0.0344 -0.0482,0.0648 -0.0786,0.091 -0.0923,0.0827 -0.18189,0.13918 -0.26871,0.16949 -0.0854,0.0303 -0.18604,0.0455 -0.30179,0.0455 -0.33349,0 -0.55811,-0.11989 -0.67386,-0.35967 -0.0648,-0.13229 -0.0978,-0.32659 -0.0978,-0.58429 v -1.35874 h 0.60359"
        id="path14740"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -307.96246,-320.77738 c 0.14883,0.12127 0.22324,0.32246 0.22324,0.60496 v 1.51722 h -0.60358 v -1.36977 c 0,-0.11851 -0.0165,-0.20946 -0.0482,-0.27285 -0.0579,-0.11576 -0.16812,-0.17364 -0.33073,-0.17364 -0.19981,0 -0.33624,0.0841 -0.41066,0.25356 -0.0386,0.0896 -0.0579,0.20396 -0.0579,0.34314 v 1.21956 h -0.58705 v -2.24896 h 0.56775 v 0.32935 c 0.0758,-0.11575 0.14746,-0.19981 0.21498,-0.2508 0.12127,-0.091 0.27561,-0.13643 0.46164,-0.13643 0.23289,0 0.42306,0.062 0.57051,0.18466"
        id="path14742"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#231f20"
        fillOpacity={1}
        d="m -307.10532,-318.2225 0.0744,0.004 c 0.0579,0.003 0.113,0 0.16537,-0.007 0.0524,-0.007 0.0965,-0.022 0.13229,-0.0469 0.0345,-0.0234 0.0661,-0.073 0.0951,-0.14745 0.0303,-0.0744 0.0427,-0.11989 0.0372,-0.13643 l -0.82682,-2.35231 h 0.65595 l 0.49195,1.66192 0.4644,-1.66192 h 0.62701 l -0.77308,2.21589 c -0.14883,0.42719 -0.26734,0.69177 -0.35415,0.79375 -0.0868,0.10335 -0.26045,0.15572 -0.5209,0.15572 -0.0524,0 -0.0937,-0.001 -0.1254,-0.003 -0.0317,0 -0.0799,-0.003 -0.14332,-0.005 v -0.47129"
        id="path14744"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="evenodd"
        fill="#231f20"
        fillOpacity={1}
        d="m -303.9565,-320.02497 c 0.10886,-0.0138 0.18603,-0.0317 0.23288,-0.0524 0.0841,-0.0358 0.12679,-0.091 0.12679,-0.16674 0,-0.0923 -0.0331,-0.15572 -0.0978,-0.19155 -0.0634,-0.0344 -0.1571,-0.0524 -0.28113,-0.0524 -0.13918,0 -0.23702,0.0344 -0.2949,0.10335 -0.0413,0.051 -0.0689,0.11989 -0.0827,0.20671 h -0.56913 c 0.0124,-0.19706 0.0675,-0.35967 0.16537,-0.48645 0.15571,-0.19844 0.42306,-0.29766 0.80201,-0.29766 0.24667,0 0.46578,0.0496 0.65733,0.14608 0.19155,0.0992 0.28801,0.28387 0.28801,0.55397 v 1.03353 c 0,0.073 10e-4,0.15985 0.004,0.26182 0.004,0.0772 0.0152,0.12954 0.0345,0.1571 0.0193,0.0276 0.0482,0.0496 0.0868,0.0675 v 0.0868 h -0.64079 c -0.0179,-0.0455 -0.0303,-0.0882 -0.0372,-0.12816 -0.007,-0.04 -0.0124,-0.0854 -0.0165,-0.13642 -0.0813,0.0882 -0.17501,0.16398 -0.28112,0.22599 -0.12678,0.073 -0.2701,0.10887 -0.42995,0.10887 -0.20395,0 -0.37207,-0.0579 -0.50574,-0.17363 -0.13229,-0.11714 -0.19844,-0.2825 -0.19844,-0.4961 0,-0.27698 0.10611,-0.47818 0.31971,-0.60082 0.11713,-0.0675 0.28939,-0.11576 0.51677,-0.1447 z m 0.35691,0.27423 c -0.0372,0.0234 -0.0744,0.0427 -0.113,0.0579 -0.0372,0.0138 -0.0896,0.0262 -0.15572,0.04 l -0.13229,0.0248 c -0.12402,0.0221 -0.21222,0.0482 -0.26596,0.0799 -0.0909,0.0537 -0.13643,0.13781 -0.13643,0.25081 0,0.10059 0.0275,0.17363 0.0827,0.2191 0.0565,0.0441 0.12402,0.0661 0.20394,0.0661 0.12678,0 0.24392,-0.0386 0.35003,-0.11162 0.10748,-0.0744 0.16261,-0.21084 0.16674,-0.4079 v -0.21911"
        id="path14746"
        style={{
          strokeWidth: 0.352778,
        }}
      />
    </g>
  </svg>
);
export default SVGComponent;
